import {HostPartialSchema, UserSchemaV3} from '@/features/authentication/services/auth.schema'
import {z} from 'zod'
import {CardUpdateTypes} from '../constants/card'
import {SubscriptionsKeysE, SubscriptionsStatusE} from '../types'

export const SubscriptionSchemaV3 = z.object({
    id: z.number(),
    amount: z.number(),
    status: z.nativeEnum(SubscriptionsStatusE),
    rookieId: z.number(),
    leaderId: z.number(),
    endedBy: z.nullable(z.unknown()),
    isRecurring: z.boolean(),
    canceledAt: z.nullable(z.unknown()),
    failedAt: z.nullable(z.unknown()),
    deletedAt: z.nullable(z.unknown()),
    subscriptionAt: z.string(),
    lastSubscriptionAt: z.string(),
    validUntilAt: z.nullable(z.unknown()),
    nextDonationAt: z.string(),
    last4: z.nullable(z.unknown()),
    creator: UserSchemaV3,
    follower: UserSchemaV3
})

const SubscriptionToRenewSchemaV3 = z.object({
    creditCard: z.object({last4: z.number()}),
    data: z.array(SubscriptionSchemaV3)
})

export const SubscriptionsSchemaToRenewCardV3 = z.object({
    [SubscriptionsKeysE.Errors]: z.array(SubscriptionToRenewSchemaV3),
    [SubscriptionsKeysE.Subscriptions]: z.array(SubscriptionToRenewSchemaV3)
})

export const SubscriptionsSchemaV3 = z.object({
    errors: z.array(z.unknown()),
    subscriptions: z.array(SubscriptionSchemaV3)
})

const SubscriptionUpdateSchema = z.object({
    id: z.string(),
    action: z.string()
})

export const SubscriptionsUpdateSchemaV3 = z.object({
    [SubscriptionsKeysE.Errors]: z.array(SubscriptionUpdateSchema).optional(),
    [SubscriptionsKeysE.Subscriptions]: z.array(SubscriptionUpdateSchema),
    needCcbill: z.boolean().optional(),
    type: z.nativeEnum(CardUpdateTypes)
})

export const AgesSchema = z.object({max_age: z.number(), min_age: z.number()})

export const SavedHostResponseSchema = z.array(HostPartialSchema)
